import DVCore from "./core/DVCore";

const TotpAPI = {};

TotpAPI.baseURL = "/api/auth/totp/";

TotpAPI.status = (onSuccess, onFail, onError = null) =>
    DVCore.get(TotpAPI.baseURL + "status", null, onSuccess, onFail, onError);

TotpAPI.enroll = (onSuccess, onFail, onError = null) =>
    DVCore.post(TotpAPI.baseURL + "enroll", null, onSuccess, onFail, onError);

TotpAPI.activate = (params, onSuccess, onFail, onError = null) =>
    DVCore.post(TotpAPI.baseURL + "activate", params, onSuccess, onFail, onError);

TotpAPI.verify = (params, onSuccess, onFail, onError = null) =>
    DVCore.post(TotpAPI.baseURL + "verify", params, onSuccess, onFail, onError);

TotpAPI.disable = (params, onSuccess, onFail, onError = null) =>
    DVCore.post(TotpAPI.baseURL + "disable", params, onSuccess, onFail, onError);

export default TotpAPI;
